
export class AlertsNavigationModule {
    static get AlertHistory(): string { return "app.alerts.history"; }
    static get ReviewAlerts(): string { return "app.alerts.review"; }
    static get Compliance(): string { return "app.alerts.compliance"; }
    static get ManageAlerts(): string { return "app.alerts.all"; }
    static get IncidentDetail(): string { return 'app.alerts.incident'; }

    static get Default(): string { return this.AlertHistory; }
    static get ParentRoot(): string { return "app.alerts"; }
}
